import LinkButton from '@/components/atoms/link-button/link-button';
import IRelatedInstitutions from '@/models/viewModels/IRelatedInstitutions';
import styles from './related-institutions.module.scss';

type Props = {
  relatedInstitutions: IRelatedInstitutions[];
};

export default function RelatedInstitutions({ relatedInstitutions }: Props) {
  return (
    <section
      id="related-institution-section"
      className={`${styles[`related-institutions-block`]} section-separator`}
    >
      <div className="d-flex align-items-lg-center flex-lg-row flex-column">
        <h2 className="m-0 font-family-lato fw-normal">Related Institutions:</h2>
        {relatedInstitutions &&
          relatedInstitutions.map((institution, index) => (
            <div
              id={`related-institutions-${index}`}
              className="d-lg-inline-block"
              key={`${institution.displayName}`}
            >
              <LinkButton link={institution.slug} text={institution.displayName} />
            </div>
          ))}
      </div>
    </section>
  );
}
